/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
// react component that copies the given text inside your clipboard
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  Route,
  Redirect,
  useHistory,
  BrowserRouter,
  Switch,
  NavLink as NavLinkRRD,
  Link,
} from 'react-router-dom';
// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from 'reactstrap';
import { chartOptions, parseOptions, chartExample2 } from 'variables/charts.js';
import { Line, Bar } from 'react-chartjs-2';
import Chart from 'chart.js';
import axiosInstance from './../../helpers/axiosInstance';
import ReactCircleModal from 'react-circle-modal';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { DateRangePicker, defaultStaticRanges } from 'react-date-range';
import Slicer from 'react-slicer';
import 'react-slicer/build/react-slicer.css';
import Paginador from './paginador';
import { useDispatch } from 'react-redux';
import {
  cambiaruta,
  cambiasidebar,
  desactivasidebar,
  actulizaInitHome,
} from '../../Slicersreducers';
import { es } from 'date-fns/locale';
import GenerateExcel from './GenerateExcel';
import MovementsProducts from './MovementsProducts';
import { data } from 'jquery';
import axios from 'axios';

const BasicData = (props) => {
  const convierteFecha = (fecha) => {
    let newFecha = fecha;
    let fecha400 = '';
    if (newFecha.getMonth() + 1 < 10) {
      fecha400 =
        newFecha.getFullYear() + '0' + (newFecha.getMonth() + 1) + fecha400;
    } else {
      fecha400 =
        newFecha.getFullYear() + '' + (newFecha.getMonth() + 1) + fecha400;
    }
    if (newFecha.getDate() < 10) {
      fecha400 = fecha400 + '0' + newFecha.getDate();
    } else {
      fecha400 = fecha400 + newFecha.getDate();
    }
    return fecha400;
  };
  function formatearFecha(fecha) {
    let newFecha = fecha;
    let formatFecha = '';
    let month;
    let year;
    let date;

    if (newFecha.getMonth() + 1 < 10) {
      month = '0' + (newFecha.getMonth() + 1);
    } else {
      month = newFecha.getMonth() + 1;
    }
    if (newFecha.getDate() < 10) {
      date = '0' + newFecha.getDate();
    } else {
      date = newFecha.getDate();
    }
    year = newFecha.getFullYear();
    formatFecha = `${date}/${month}/${year}`;

    return formatFecha;
  }
  const periodoGrafica = () => {
    let diasSemana = [
      'Domingo',
      'Lunes',
      'Martes',
      'Miercoles',
      'Jueves',
      'Viernes',
      'Sabado',
    ];
    let meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    let periodo =
      'Del ' +
      diasSemana[newFechaI.getDay()] +
      ', ' +
      newFechaI.getDate() +
      ' de ' +
      meses[newFechaI.getMonth()] +
      ' del ' +
      newFechaI.getFullYear() +
      '. al ' +
      diasSemana[newFechaF.getDay()] +
      ', ' +
      newFechaF.getDate() +
      ' de ' +
      meses[newFechaF.getMonth()] +
      ' del ' +
      newFechaF.getFullYear();
    return periodo;
  };

  const [SaldoTot, setSaldoTot] = useState(0);
  const [MovCuenta, setMovCuenta] = useState([]);
  const [newFechaI, setnewFechaI] = useState(new Date());
  const [newFechaF, setnewFechaF] = useState(new Date());
  const [entradasCuenta, setentradasCuenta] = useState(0);
  const [salidasCuenta, setsalidasCuenta] = useState(0);
  const [estiloTrans, setestiloTrans] = useState([]);
  const [perGraf, setperGraf] = useState(periodoGrafica());
  const [barras, setbarras] = useState(['0%', '0%']);
  const [filterMov, setfilterMov] = useState(false);
  const [Descript, setDescript] = useState('');
  const [Supervision, setSupervision] = useState('');
  const [Type, setType] = useState('');
  const [listaextractos,setlistaextractos]=useState([]);
  const dispacher = useDispatch();

  const buscaMov = async () => {
    setfilterMov(true);
    const entradaMovimientos = {
      accountNumber: props.accountNumber,
      productType: '1',
      page: 'NJ203000',
      parameters: [
        props.accountNumber,
        convierteFecha(newFechaI),
        convierteFecha(newFechaF),
      ],
    };

    const apiUrlMov = '/WSGYG39_2/api/Inquiries/CurrentAccountMovements';
    const resmov = await axiosInstance()
      .post(apiUrlMov, entradaMovimientos)
      .catch((err) => {
        setMovCuenta([]);
        alert('Hay un problema. Vuelve atras');
      });
    if (resmov != 'err') {
      console.log('gato');
      console.log(resmov.data);
      if (resmov.data.transactionHistory.length > 0) {
        let entradas = 0;
        let salidas = 0;
        let estilo = [];
        let valorProv;
        for (let i = 0; i < resmov.data.transactionHistory.length; i++) {
          valorProv = parseFloat(
            resmov.data.transactionHistory[i].transactionBalance.replaceAll(
              ',',
              ''
            )
          );
          if (valorProv >= 0) {
            estilo.push('green');
            entradas += valorProv;
          } else {
            estilo.push('red');
            salidas += valorProv;
          }
        }
        if (entradas > -1 * salidas) {
          setbarras(['100%', ((-1 * salidas) / entradas) * 100 + '%']);
        } else {
          setbarras([(entradas / (-1 * salidas)) * 100 + '%', '100%']);
        }

        setentradasCuenta(Math.round(entradas * 100) / 100);
        setsalidasCuenta(Math.round(salidas * 100) / 100);
        setestiloTrans(estilo);
        setperGraf(periodoGrafica());
      }
      setMovCuenta(resmov.data.transactionHistory);
    }
  };
  var minDate = new Date();
  minDate.setMonth(minDate.getMonth() - 6);

  useEffect(async () => {
    dispacher(cambiaruta('Inicio/Movimientos'));
    dispacher(cambiasidebar(false));
    dispacher(desactivasidebar());
    dispacher(actulizaInitHome(false));
    const apiUrl = '/WSGYG39_2/api/Inquiries/Products';
    const res = await axiosInstance()
      .get(apiUrl)
      .catch((err) => {
        alert('Hay un problema. Vuelve atras');
      });
    if (res != 'err') {
      let saldo = 0;
      let descripcion;
      let type;
      for (let i = 0; i < res.data.summaryProducts.products.length; i++) {
        if (
          res.data.summaryProducts.products[i].accountNumber ==
          props.accountNumber
        ) {
          saldo = res.data.summaryProducts.products[i].balance;
          type = res.data.summaryProducts.products[i].accountType;
          descripcion = res.data.summaryProducts.products[i].description;
          //descripcion = 'Descripcion del producto -1';
        }
      }

      let descripcionTrim = descripcion
        .substring(0, descripcion.length - 1)
        .trim();
      let supervision = descripcion.charAt(49);
      if (descripcionTrim === '') {
        descripcionTrim = 'CUENTA VISTA/CONVENIOS ';
      }
      setSaldoTot(saldo);
      setType(type);
      setDescript(descripcionTrim);
      setSupervision(supervision);
    }
    consultaextractos()
    //buscaMov();
  }, []);

  const [rangoFechas, setrangoFechas] = useState([
    {
      startDate: newFechaI,
      endDate: newFechaF,
      key: 'selection',
    },
  ]);

  const consultaextractos=async()=>{
    try{
      const apiUrl = '/WSGYG39_2/api/AccountStatement/AccountNumber?AccountNumber=' + props.accountNumber;
     
      const res = await axiosInstance()
        .get(apiUrl)
        .catch((err) => {
          alert('Hay un problema. Vuelve atras');
        });
        if (res != 'err') {
          console.log('consulta lista extractos');
          console.log(res.data);
          setlistaextractos(res.data);
          /*estructura respuesta
          [
            {
            "report_id": "61677c87-47be-4e45-9aa5-5a8144fe8a62",
            "report_name": "WWB033    ",
            "report_date": "2023-01-01T00:00:00
            },
            {},
            .
          ]
          */
        }

    }catch(e){
      console.log(e)
    }
  }
  const descargaextracto=async(idextracto,mesextracto)=>{
    try{
      const apiUrl = '/WSGYG39_2/api/AccountStatement/ReportId?reportId=' + idextracto;
      const res = await axiosInstance()
        .get(apiUrl,{responseType: 'arraybuffer'})
        .catch((err) => {
          alert('Hay un problema. Vuelve atras');
        });
        if (res != 'err') {
          console.log('descarga extracto');
          console.log(res.data);
          const file = new Blob([res.data],{
            type: 'application/octet-stream'
          });
          const url = URL.createObjectURL(file); 
          
          const a = document.createElement('a');
          a.href = url;
          a.download = `Extracto mensual de ${mesextracto}.pdf`;
          a.type = 'application/pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }

    }catch(e){
      console.log(e)
    }
  }
  const Modalextractos=(props)=>{
    return(
      <ReactCircleModal
        backgroundColor=''
        toogleComponent={(onClick) => (
          <div class="card-profile-stats d-flex justify-content-center">
            <div className="">
              <i onClick={onClick} className="far fa-file-alt mousepointer" />
              <p class="">Extractos</p>
            </div>
          </div>
        )}
        // Optional fields and their default values
        offsetX={'50%'}
        offsetY={'50%'}
      >
        {(onClick) => (
          
          <div className='flexleftcenter contenedorblur' style={{ padding: '1em' }}>
            <div className='flexrowbetween'>
              <h4 style={{ fontWeight: 600, fontSize: 20 + 'px' }}>
                Lista de extractos
              </h4>
              <i onClick={onClick} class="bi bi-x-square-fill"></i>
            </div>
            {
              listaextractos.map((item,index)=>{
                let fechaextracto=item.report_date.slice(0,7).replace("/-/g","/")
                return(
                <div
                  className="card-transaction-info ml-5 mr-5"
                  style={{ marginBottom: '24px' }}
                  key={index}
                  onClick={()=>{
                    descargaextracto(item.report_id,fechaextracto)
                    onClick()
                  }}
                >
                  <p>
                    Extracto mensual de {fechaextracto}
                  </p>
                  
                </div>
              
              )})
            }
            
            
          </div>
        )}
      </ReactCircleModal>
    )
  }

  const Pruebacomponente = (props) => {
    return (
      <Card
        className="shadow "
        style={{ padding: 5 + 'px', margin: '5px 15px 15px 15px' }}
      >
        <div className="">
          <Row style={{ alignItems: 'center' }}>
            <div
              className="col-auto mr-3 ml-2 text-medium-grey"
              style={{ alignItems: 'center' }}
            >
              <p style={{ marginBottom: 0, fontSize: '12px' }}>
                {props.data.transactionDate.substring(0, 4)}
                <br />
                {props.data.transactionDate.substring(5)}
              </p>
            </div>
            <div className="col">
              <Row>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 0 + 'px',
                  }}
                >
                  <p
                    style={{
                      fontWeight: 700,
                      margin: '2px 0 0 0px',
                      fontSize: '12px',
                    }}
                  >
                    {' '}
                    {props.data.transactionName}
                  </p>
                </div>
              </Row>
              <Row>
                <span
                  style={{ marginBottom: 0, fontWeight: 700, fontSize: '12px' }}
                  class="mb-2 text-sm"
                >
                  Cuenta de Ahorros No. {props.data.accountNumber}{' '}
                </span>
              </Row>
            </div>
            <div className="col-auto mr-3 vertical-center">
              <h6
                style={{
                  fontWeight: 600,
                  fontSize: 1 + 'rem',
                  marginBottom: 0,
                  color: estiloTrans[props.indexelem],
                }}
              >
                <i className="fas fa-dollar-sign" />{' '}
                {props.data.transactionBalance}
              </h6>
            </div>
          </Row>
        </div>
      </Card>
    );
  };

  const ListMovimientos = (props) => {
    //let cuerpo=[11,22,33,44,55,66,77,88,99,111,222,333,444,555,666,777,888,999,1111,2222,3333,4444,5555,6666]
    let listahistorico = [];
    let registroHis = {
      transactionDate: '',
      transactionName: '',
      accountNumber: '',
      transactionBalance: '',
    };
    for (let i = 0; i < props.historicoTransacciones.length; i++) {
      registroHis.transactionDate =
        props.historicoTransacciones[i].transactionDate;
      registroHis.transactionName =
        props.historicoTransacciones[i].transactionName;
      registroHis.accountNumber = props.accountNumber;
      registroHis.transactionBalance =
        props.historicoTransacciones[i].transactionBalance;
      listahistorico.push(JSON.parse(JSON.stringify(registroHis)));
    }
    return (
      <div className="cuerpopaginador">
        <Paginador
          Componentepag={Pruebacomponente}
          datos={listahistorico}
          numitems={5}
          numpag={3}
        ></Paginador>
      </div>
    );
  };
  const functionListMov = (lista) => {
    setMovCuenta(lista);
  };

  return (
    <div lg="12" xl="12" className="">
      <Card className="mb-xl-0 shadow pl-5 pr-5">
        <div className="bg-transparent row m-0">
          <div class="card-profile-stats d-flex justify-content-between col">
            <div style={{ textAlign: 'left' }}>
              <span class="heading">{Descript}</span>
              <span class="description">No. {props.accountNumber}</span>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span class="heading">
                {Supervision === 'S' ? 'Cuenta con Supervisión' : ''}
              </span>
            </div>
          </div>
          <Modalextractos></Modalextractos>
        </div>
        <CardBody className="pb-1 row">
          <div className="col-md-8">
            <Row style={{ marginBottom: 30 + 'px' }}>
              <div className="col-md-6">
                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                  {' '}
                  Saldo total{' '}
                </h6>
                <h5 style={{ fontSize: 1.25 + 'rem' }}>
                  <NumberFormat
                    value={SaldoTot}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                  />
                </h5>
              </div>
              <div className="col-md-6">
                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                  {' '}
                  <i className="fas fa-money-bill" /> Saldo disponible{' '}
                </h6>
                <h5 style={{ fontSize: 1.25 + 'rem' }}>
                  <NumberFormat
                    value={SaldoTot}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={'$'}
                  />
                </h5>
              </div>
            </Row>
            <Row style={{ marginBottom: 30 + 'px' }}>
              <div className="col-md-6">
                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                  {' '}
                  <i className="fas fa-ban" /> Saldo bloqueado{' '}
                </h6>
                <h5 style={{ fontSize: 1.25 + 'rem' }}> $0,0 </h5>
              </div>
              <div className="col-md-6">
                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                  {' '}
                  <i className="fas fa-database" /> Saldo en canje{' '}
                </h6>
                <h5 style={{ fontSize: 1.25 + 'rem' }}> $0,0 </h5>
              </div>
            </Row>
          </div>
          <div className="col-md-4">
            <Row>
              <div className="col-12">
                <h6 style={{ fontSize: 1 + 'rem', fontWeight: 500 }}>
                  {' '}
                  <i className="fas fa-chart-bar text-danger" /> {perGraf}{' '}
                </h6>
              </div>
            </Row>
            <Row>
              <div _ngcontent-eqv-c27="" class="graphs-body">
                <div _ngcontent-eqv-c27="" class="drawing">
                  <span
                    _ngcontent-eqv-c27=""
                    class="rectangle in"
                    style={{ height: barras[0] }}
                  ></span>
                  <span
                    _ngcontent-eqv-c27=""
                    class="rectangle out"
                    style={{ height: barras[1] }}
                  ></span>
                </div>
                <div _ngcontent-eqv-c27="" class="info">
                  <div class="in">
                    <p _ngcontent-eqv-c27=""> Dinero que entró: </p>
                    <h6 _ngcontent-eqv-c27="">
                      <NumberFormat
                        value={entradasCuenta}
                        displayType={'text'}
                        thousandSeparator={true}
                      />
                    </h6>
                  </div>
                  <div _ngcontent-eqv-c27="">
                    <p _ngcontent-eqv-c27=""> Dinero que salió: </p>
                    <h6 _ngcontent-eqv-c27="">
                      <NumberFormat
                        value={salidasCuenta}
                        displayType={'text'}
                        thousandSeparator={true}
                      />
                    </h6>
                  </div>
                </div>
              </div>
            </Row>
          </div>
          <div
            className="col-md-12"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'relative',
              margin: '24px 15px',
            }}
          >
            <h4 style={{ fontWeight: 600, fontSize: 28 + 'px' }}>
              Mis movimientos
            </h4>

            <div style={{ display: 'flex', alignItems: 'center' }}>
              {filterMov ? (
                <p style={{ fontWeight: 400, margin: 0 }}>
                  {' '}
                  Desde{' '}
                  <b>
                    {newFechaI.getFullYear() +
                      '/' +
                      (newFechaI.getMonth() + 1) +
                      '/' +
                      newFechaI.getDate()}
                  </b>{' '}
                  hasta{' '}
                  <b>
                    {newFechaF.getFullYear() +
                      '/' +
                      (newFechaF.getMonth() + 1) +
                      '/' +
                      newFechaF.getDate()}
                  </b>
                </p>
              ) : (
                ''
              )}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginLeft: 10 + 'px',
                }}
              >
                <ReactCircleModal
                  backgroundColor=""
                  toogleComponent={(onClick) => (
                    <button className="btn btn-success" onClick={onClick}>
                      <i className="fas fa-calendar-alt" />
                    </button>
                  )}
                  // Optional fields and their default values
                  offsetX={'50%'}
                  offsetY={'50%'}
                >
                  {(onClick) => (
                    <div style={{ padding: '1em' }}>
                      <Row>
                        <DateRangePicker
                          onChange={(item) => {
                            setrangoFechas([item.selection]);
                            setnewFechaI(item.selection.startDate);
                            setnewFechaF(item.selection.endDate);
                          }}
                          minDate={minDate}
                          showSelectionPreview={true}
                          moveRangeOnFirstSelection={false}
                          months={1}
                          ranges={rangoFechas}
                          direction="horizontal"
                          lang="es"
                          locale={es}
                          staticRanges={[
                            {
                              ...defaultStaticRanges[0],
                              label: 'Hoy',
                            },
                            {
                              ...defaultStaticRanges[1],
                              label: 'Ayer',
                            },
                            {
                              ...defaultStaticRanges[2],
                              label: 'Esta Semana',
                            },
                            {
                              ...defaultStaticRanges[3],
                              label: 'La Última Semana',
                            },
                            {
                              ...defaultStaticRanges[4],
                              label: 'Este Mes',
                            },
                            {
                              ...defaultStaticRanges[5],
                              label: 'Último Mes',
                            },
                          ]}
                          inputRanges={[]}
                        />
                      </Row>
                      <Row>
                        <button onClick={onClick} className="btn btn-success">
                          Cerrar calendario
                        </button>
                      </Row>
                    </div>
                  )}
                </ReactCircleModal>
                <button
                  className="btn btn-success"
                  onClick={buscaMov}
                  style={{ margin: '1em' }}
                >
                  {' '}
                  Filtrar
                </button>
                {MovCuenta.length != 0 ? (
                  <GenerateExcel
                    indicador="1"
                    nombre={Descript}
                    numero={props.accountNumber}
                    fecha={formatearFecha(newFechaI)}
                    salDispo={SaldoTot}
                    salTotal={SaldoTot}
                    supervision={Supervision === 'S' ? true : false}
                    movCuenta={MovCuenta}
                  ></GenerateExcel>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          {filterMov ? (
            <ListMovimientos
              historicoTransacciones={MovCuenta}
              accountNumber={props.accountNumber}
            ></ListMovimientos>
          ) : (
            <MovementsProducts
              product={props}
              type={Type}
              functionListMov={functionListMov}
            ></MovementsProducts>
          )}

          {/*
                                <Card className="shadow col-md-12" style={{padding:20+'px', margin: "5px 15px 15px 15px"}}>
                                    <div className="">
                                        <Row style={{alignItems:"center"}}>
                                            <div className="col-auto mr-3" style={{alignItems:"center"}}>
                                                <p style={{marginBottom:0}}>8/4<br/>2021</p>
                                            </div>
                                            <div className="col">
                                                <Row>
                                                    <div style={{ display: "flex", alignItems: "center", marginLeft: 10 + 'px' }}>
                                                        <i className="fas fa-dollar-sign" />
                                                        <p style={{ fontWeight: 400, margin: '2px 0 0 5px' }}> Debito cargo prima bancaseguros alfa cuenta pro internet                               </p>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <span style={{marginBottom:0}} class="mb-2 text-sm">Cuenta de Ahorros No. 702766010</span>
                                                </Row>
                                            </div>
                                            <div className="col-auto mr-3 vertical-center">
                                                <h6 style={{fontWeight:600, fontSize:1+'rem', marginBottom:0}}> - $14.620,<span class="decimal-numbers-format">00</span></h6>
                                            </div>
                                        </Row>
                                    </div>
                                </Card>

                                <Card className="shadow col-md-12" style={{padding:20+'px', margin: "5px 15px 15px 15px"}}>
                                    <div className="">
                                        <Row style={{alignItems:"center"}}>
                                            <div className="col-auto mr-3" style={{alignItems:"center"}}>
                                                <p style={{marginBottom:0}}>8/4<br/>2021</p>
                                            </div>
                                            <div className="col">
                                                <Row>
                                                    <div style={{ display: "flex", alignItems: "center", marginLeft: 10 + 'px' }}>
                                                        <i className="fas fa-dollar-sign" />
                                                        <p style={{ fontWeight: 400, margin: '2px 0 0 5px' }}> Debito cargo prima bancaseguros alfa cuenta pro internet                               </p>
                                                    </div>
                                                </Row>
                                                <Row>
                                                    <span style={{marginBottom:0}} class="mb-2 text-sm">Cuenta de Ahorros No. 702766010</span>
                                                </Row>
                                            </div>
                                            <div className="col-auto mr-3 vertical-center">
                                                <h6 style={{fontWeight:600, fontSize:1+'rem', marginBottom:0}}> - $14.620,<span class="decimal-numbers-format">00</span></h6>
                                            </div>
                                        </Row>
                                    </div>
                                </Card>
                            */}
        </CardBody>
      </Card>
    </div>
  );
};

const ProductsCard = () => {
  return <></>;
};

const Movements = (props) => {
  const [accountNumber, setaccountNumber] = useState(
    props.location.state.accountNumber
  );
  return (
    <>
      <div className="pb-1 pt-1 pt-md-7">
        <Container fluid>
          <div className="header-body">
            <Row>
              <BasicData accountNumber={accountNumber}></BasicData>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};
export default Movements;
